module.exports = __webpack_public_path__ + "static/media/logo4.1d88d4fc.png";